import I18n from '../../config/locales';

export const SIGNUP_REQUEST = 'SIGNUP_REQUEST';
export const RESEND_OTP_REQUEST = 'RESEND_OTP_REQUEST';
export const RESEND_OTP_SUCCESS = 'RESEND_OTP_SUCCESS';
export const RESEND_OTP_FAILURE = 'RESEND_OTP_FAILURE';
export const SET_PASSWORD_REQUEST = 'SET_PASSWORD_REQUEST';
export const SET_PASSWORD_FAILURE = 'SET_PASSWORD_FAILURE';
export const COUNTRY_LIST_REQUEST = 'COUNTRY_LIST_REQUEST';
export const COUNTRY_LIST_SUCCESS = 'COUNTRY_LIST_SUCCESS';
export const COUNTRY_LIST_FAILURE = 'COUNTRY_LIST_FAILURE';
export const SET_MESSAGE_REQUEST = 'SET_MESSAGE_REQUEST';
export const VALIDATE_COMPANY_REQUEST = 'VALIDATE_COMPANY_REQUEST';
export const VALIDATE_COMPANY_SUCCESS = 'VALIDATE_COMPANY_SUCCESS';
export const VALIDATE_COMPANY_FAILURE = 'VALIDATE_COMPANY_FAILURE';
export const SET_VALIDATE_COMPANY = 'SET_VALIDATE_COMPANY';

export const defaultErrorMessage = () => {
  return {
    FIELD_REQUIRED: I18n.t('registration.fieldRequired'),
    VALID_EMAIL: I18n.t('registration.validEmail'),
    VALID_PHONE: I18n.t('registration.validPhone'),
    VALID_CHAMBER: I18n.t('registration.validChamberNumber')
  };
};
